import React, { useEffect, useState } from "react";
import { AiOutlineFileSearch } from "react-icons/ai";
import { IoSearch } from "react-icons/io5";
import { FaHandPointDown, FaHandPointRight } from "react-icons/fa";
import { useQuery } from "react-query";
import { USERS } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import DrawerLoading from "../DrawerLoading";
import ForbiddenQueriesPermission from "../common/ForbiddenQueriesPermission";
import RelatorioEssencialPJQuery from "../queries/RelatorioEssencialPJQuery";
import RelatorioEssencialPFQuery from "../queries/RelatorioEssencialPFQuery";
import RelatorioAvancadoPJQuery from "../queries/RelatorioAvancadoPJQuery";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import RelatorioAvancadoPFQuery from "../queries/RelatorioAvancadoPFQuery";
import { FiAlertTriangle } from "react-icons/fi";
import { Alert } from "flowbite-react";

const QueriesCreditTable = () => {
  const [selectedQuery, setSelectedQuery] = useState({ id: 3 });
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("ALL");

  const { isLoading, data: userQueryPermissions } = useQuery(
    ["userQueryPermissions"],
    async () => {
      const { data: items } = await axios.get(
        `${USERS.GET_USER_QUERY_PERMISSIONS}`
      );
      return items.data.filter((query) => query.categoryId === 1);
    }
  );

  useEffect(() => {
    if (selectedQuery) {
      const matchingQuery = userQueryPermissions?.find(
        (query) => query.id === selectedQuery?.id
      );
      setSelectedPrice(matchingQuery?.price);
    }
  }, [selectedQuery, userQueryPermissions]);

  const filteredQueries = userQueryPermissions?.filter((query) =>
    query?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const queries = [
    {
      id: 1,
      name: "Relatórios Essenciais PJ",
      component: (
        <RelatorioEssencialPJQuery
          query={selectedQuery}
          selectedPrice={selectedPrice}
        />
      ),
      type: "CNPJ",
    },
    {
      id: 2,
      name: "Relatórios Essenciais PF",
      component: (
        <RelatorioEssencialPFQuery
          query={selectedQuery}
          selectedPrice={selectedPrice}
        />
      ),
      type: "CPF",
    },
    {
      id: 3,
      name: "Relatórios Avançados PJ",
      component: (
        <RelatorioAvancadoPJQuery
          query={selectedQuery}
          selectedPrice={selectedPrice}
        />
      ),
      type: "CNPJ",
    },
    {
      id: 4,
      name: "Relatórios Avançados PF",
      component: (
        <RelatorioAvancadoPFQuery
          query={selectedQuery}
          selectedPrice={selectedPrice}
        />
      ),
      type: "CPF",
    },
  ];

  return (
    <div className="w-full p-3">
      {isLoading && <DrawerLoading />}

      {userQueryPermissions?.length > 0 ? (
        <>
          <div className="text-left mb-3 px-2">
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-700">
              Consultas disponíveis para você
            </h2>
            <div className="h-1 w-12 bg-green-500 rounded mt-1" />
          </div>

          <div className="relative w-full overflow-x-auto mb-5 p-2 rounded-xl border border-gray-100 bg-gray-200 shadow-[0_8px_20px_rgba(0,0,0,0.04)] ring-1 ring-gray-200 backdrop-blur-sm">
            <Swiper
              grabCursor={true}
              slidesPerView={"auto"}
              spaceBetween={10}
              className="!overflow-visible"
            >
              {filteredQueries?.map((query) => {
                const matched = queries.find((q) => q.id === query.id);
                const isSelected = selectedQuery?.id === query.id;
                const isActiveTab =
                  activeTab === "ALL" ||
                  matched?.type === activeTab ||
                  matched?.type === "ALL";

                return (
                  isActiveTab && (
                    <SwiperSlide key={query.id} className="!w-fit">
                      <div
                        onClick={() => setSelectedQuery(query)}
                        className={`
                          relative cursor-pointer 
                          min-w-[250px] w-fit p-3 rounded-xl shadow-md border-2 
                          my-2 h-full
                          ${
                            isSelected
                              ? "bg-green-200 border-green-600"
                              : "bg-white border-gray-200"
                          }
                        `}
                      >
                        {isSelected && (
                          <div className="absolute top-1 right-1 text-green-700">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                        )}
                        <p className="font-semibold text-gray-800 text-xs uppercase leading-5 truncate whitespace-nowrap">
                          {query.name}
                        </p>
                        <p
                          className={`text-xs ${
                            isSelected
                              ? "text-green-700 font-medium"
                              : "text-gray-500"
                          }`}
                        >
                          {isSelected
                            ? "Consulta selecionada"
                            : "Clique para selecionar"}
                        </p>
                      </div>
                    </SwiperSlide>
                  )
                );
              })}
            </Swiper>
          </div>

          <div className="mt-3">
            {selectedQuery &&
              queries.find((q) => q.id === selectedQuery?.id)?.component}
          </div>
        </>
      ) : (
        <ForbiddenQueriesPermission />
      )}
    </div>
  );
};

export default QueriesCreditTable;
